import Framed from '../../src/legacy/Framed';
export default Framed;
